import { useQuery } from '@tanstack/react-query'
import { useApi } from '@/lib/api'

/** La carpeta de Drive del cliente del proyecto (Fase 6). Sólo la pide RASTRO. */
export function useCarpetaDrive(proyectoId: string, esRastro: boolean) {
  const api = useApi()
  return useQuery({
    queryKey: ['carpeta-drive', proyectoId],
    queryFn: async () =>
      (
        await api<{ carpeta: string | null }>(
          `/api/drive/carpeta?proyecto=${encodeURIComponent(proyectoId)}`,
        )
      ).carpeta,
    enabled: esRastro && Boolean(proyectoId),
    staleTime: 5 * 60_000,
  })
}
